import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const File_Edit = () => {
  const { sNo } = useParams();
  const [subDetails, setSubDetails] = useState([]);
 const [heading, setHeading] = useState([]);
  const [subHeading, setSubHeading] = useState([]);
  const [innerHeading, setInnerHeading] = useState([]);
  const [formData, setFormData] = useState({title: "", order: "", link: "", subDepartment: "", dept: ""});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_heading");
        setHeading(response.data.heading);
      } catch (error) {
        console.error("Error fetching heading:", error);
      }
    };
    fetchHeading();
  }, []);

  useEffect(() => {
    const fetchSubHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_subHeading");
        setSubHeading(response.data.subheading);
      } catch (error) {
        console.error("Error fetching subheading:", error);
      }
    };
    fetchSubHeading();
  }, []);

  useEffect(() => {
    const fetchInnerHeading = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/fileList_innerSubHeading");
        setInnerHeading(response.data.innersub);
      } catch (error) {
        console.error("Error fetching inner heading:", error);
      }
    };
    fetchInnerHeading();
  }, []);

  

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/fileListing_editFetch?slNo=${sNo}`);
        const items = response.data.fetchData;
        console.log(response.data.fetchData);
        
        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            heading: item.fld_heading,
            subHeading: item.fld_subheading,
            innerSub: item.fld_innersubheading,
            sort: item.fld_sort,
            fileName: item.fld_txtfilename,
             fileDesc: item.fld_filedescription,
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            heading: storeReqHeader1.heading,
            subHeading: storeReqHeader1.subHeading,
            innerSub: storeReqHeader1.innerSub,
            sort: storeReqHeader1.sort,
            fileName: storeReqHeader1.fileName,
            fileDesc: storeReqHeader1.fileDesc,
          });
        }
      } catch (error) {
        console.error("Error fetching supplier details:", error);
      }
    };
  
    fetchSupplierDetails();
}, [sNo]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
          heading: formData.heading,
            subHeading: formData.subHeading,
            innerSub: formData.innerSub,
            sort: formData.sort,
            fileName: formData.fileName,
            fileDesc: formData.fileDesc,
            slNo: sNo,
    };
    console.log(payload);
    

    try {
          Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });

        const response = await axios.put("https://rfs2.infraconsoft.net.in/api/fileList_edit", payload);
        Swal.fire("Success", response.data.message, "success");
        navigate(`/admin/file_listing`);
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            Swal.fire("Error", error.response.data.message, "error");
        } else {
            Swal.fire("Error", "Submission failed. Please try again.", "error");
        }
    }
  };

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
            <div className="back-div">
            <h2 className="add-txt">File Listing - Edit</h2>
            <Link to={`/admin/file_listing`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
          <div className="form-group">
                <label>Heading :</label>
                <select name="heading"  value={formData.heading}  onChange={handleInputChange} >
            <option value="">Select Heading</option>
            {heading.map((item) => (
              <option key={item.fld_heading} value={item.fld_heading}>
                {item.fld_heading}
              </option>
            ))}
          </select>
              </div>
              <div className="form-group">
                <label>Sub Heading :</label>
                <select name="subHeading"  value={formData.subHeading}  onChange={handleInputChange} >
            <option value="">Select Sub Heading</option>
            {subHeading.map((item) => (
              <option key={item.fld_subheading} value={item.fld_subheading}>
                {item.fld_subheading}
              </option>
            ))}
          </select>
              </div>
            </div>




          <div className="form-row">
              <div className="form-group">
                <label>Inner Sub Heading :</label>
                <select name="innerSub"  value={formData.innerSub}  onChange={handleInputChange} >
            <option value="">Select Inner Sub Heading</option>
            {innerHeading.map((item) => (
              <option key={item.fld_addsubHeading} value={item.fld_addsubHeading}>
                {item.fld_addsubHeading}
              </option>
            ))}
          </select>
              </div>
              <div className="form-group">
                <label>Sort Order :</label>
                <input type="text" name="sort" value={formData.sort} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>File Name:</label>
                <input type="text" name="fileName" value={formData.fileName} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>File Description</label>
                <input type="text" name="fileDesc" value={formData.fileDesc} onChange={handleInputChange} />
              </div>
            </div>

          
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default File_Edit;
